module.exports = __webpack_public_path__ + "images/illustrations/illustration-construction-worker-767a642a58b14a27d61a15ec87cae90c.webp";